import { render, staticRenderFns } from "./Botfooter.vue?vue&type=template&id=1a96011b&"
import script from "./Botfooter.vue?vue&type=script&lang=js&"
export * from "./Botfooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports